module.exports = __webpack_public_path__ + "img/OfficeBalance_logo.e6d404a.svg";